module.exports = __webpack_public_path__ + "static/cultivation_final-3864ce0c7b71b4144eee663f6f40ee25.png";